(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blessy-pdp-aniversario-sabores"] && !Shopify.designMode) return;
  try {
    
  class BlessyPdpAniversarioSabores extends HTMLElement {
    connectedCallback() {
      const cfgNode = this.querySelector('[data-bpas-config]');
      this._config = cfgNode ? JSON.parse(cfgNode.textContent) : { pricingTiers: {}, flavorMeta: {} };

      const params = new URLSearchParams(window.location.search);
      this._combo = params.get('combo') || 'aniversario';
      const rawQty = parseInt(params.get('quantity'), 10);
      this._qtyTarget = Math.max(1, Math.min(20, isNaN(rawQty) ? this._defaultQtyForCombo() : rawQty));

      this._selections = new Map();
      this._submitting = false;
      this._notyf = null;
      this._notyfPromise = null;
      this._upsell = null;

      this._pricing = this._pricingFor(this._qtyTarget);

      window.__bpas = this;
      console.log('[bpas] connected | combo=' + this._combo + ' qtyTarget=' + this._qtyTarget + ' cards=' + this.querySelectorAll('[data-flavor-card]').length);

      this._applyFlavorMeta();
      this._bindFlavorCards();
      this._bindCta();
      this._bindBackBtn();
      this._syncStaticUi();
      this._update();
      this._setupNotyfIdleLoad();
    }

    _bindBackBtn() {
      const back = this.querySelector('.back-btn');
      if (!back) return;
      const baseHref = back.getAttribute('href') || this.dataset.urlPdp || '/pages/campanha-aniversario';
      try {
        const target = new URL(baseHref, window.location.origin);
        const current = new URLSearchParams(window.location.search);
        const preserve = ['preview_theme_id', 'utm_source', 'utm_medium', 'utm_campaign',
                          'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid', 'msclkid', 'twclid'];
        for (const key of preserve) {
          const v = current.get(key);
          if (v) target.searchParams.set(key, v);
        }
        back.href = target.pathname + (target.search || '');
        console.log('[bpas] back-btn href set:', back.href);
      } catch (e) {
        console.log('[bpas] back-btn href update failed:', e);
      }
      back.addEventListener('click', (e) => {
        e.preventDefault();
        const dest = back.getAttribute('href');
        console.log('[bpas] back-btn clicked, navigating to:', dest);
        if (dest) window.location.href = dest;
      });
    }

    _defaultQtyForCombo() {
      const map = {
        descoberta:  parseInt(this.dataset.qtyDescoberta,  10),
        bestie:      parseInt(this.dataset.qtyBestie,      10),
        aniversario: parseInt(this.dataset.qtyAniversario, 10)
      };
      return map[this._combo] || 5;
    }

    _pricingFor(qty) {
      const tiers = this._config.pricingTiers || {};
      if (tiers[qty]) return tiers[qty];
      const rate = qty <= 1 ? 18990
                 : qty <= 2 ? 14990
                 : qty <= 4 ? 10900
                 : qty <= 7 ?  9340
                 :             8500;
      const now    = rate * qty;
      const strike = Math.round(21300 * qty);
      return { perPote: rate, strike, now };
    }

    _fmtBRL(cents) {
      const n = cents / 100;
      return 'R$' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    _applyFlavorMeta() {
      const meta = this._config.flavorMeta || {};
      this.querySelectorAll('[data-flavor-card]').forEach((card) => {
        const slug = card.dataset.flavorSlug;
        const m = meta[slug];
        if (!m) return;

        const vetorWrap = card.querySelector('[data-flavor-vetor]');
        if (vetorWrap && m.vetorUrl) {
          vetorWrap.innerHTML = '<img src="' + m.vetorUrl + '" alt="" />';
        }

        const badgeEl = card.querySelector('[data-flavor-badge]');
        if (badgeEl) {
          if (m.badge) {
            badgeEl.className = 'flavor-badge is-' + m.badge;
            badgeEl.textContent = m.badgeText || '';
            badgeEl.hidden = false;
          } else {
            badgeEl.hidden = true;
          }
        }
      });
    }

    _syncStaticUi() {
      const pickerTitle = this.querySelector('[data-picker-title]');
      if (pickerTitle) {
        pickerTitle.textContent = this._qtyTarget === 1
          ? 'Escolha seu sabor'
          : 'Escolha seus ' + this._qtyTarget + ' sabores';
      }

      const counterMax = this.querySelector('[data-counter-max]');
      if (counterMax) counterMax.textContent = String(this._qtyTarget);

      const unlockEl   = this.querySelector('[data-unlock]');
      const unlockText = this.querySelector('[data-unlock-text]');
      if (unlockEl && unlockText) {
        unlockEl.classList.remove('is-pote-1', 'is-pote-2');
        if (this._qtyTarget >= 4) {
          unlockEl.classList.add('is-pote-2');
          unlockText.innerHTML = 'Você desbloqueou <b>frete grátis + 2 potes grátis + 1 brinde extra</b>';
        } else if (this._qtyTarget >= 2) {
          unlockEl.classList.add('is-pote-1');
          unlockText.innerHTML = 'Você desbloqueou <b>frete grátis + 1 pote grátis + 1 brinde extra</b>';
        } else {
          unlockText.innerHTML = 'Você desbloqueou <b>frete grátis + 1 brinde extra</b>';
        }
      }

      const off = this._pricing.strike - this._pricing.now;
      const priceOff = this.querySelector('[data-price-off]');
      if (priceOff) priceOff.textContent = this._fmtBRL(off) + ' OFF';
      const priceStrike = this.querySelector('[data-price-strike]');
      if (priceStrike) priceStrike.textContent = 'De ' + this._fmtBRL(this._pricing.strike);
      const priceNow = this.querySelector('[data-price-now]');
      if (priceNow) priceNow.textContent = this._fmtBRL(this._pricing.now);
    }

    _bindFlavorCards() {
      this.querySelectorAll('[data-flavor-card]').forEach((card) => {
        const slug = card.dataset.flavorSlug;
        if (!slug) return;
        if (card.dataset.flavorAvailable !== 'true') return;
        if (card.dataset.forceSoldout === 'true') return;

        card.querySelectorAll('[data-qty-inc]').forEach((btn) => {
          btn.addEventListener('click', () => this._adjust(card, +1));
        });
        card.querySelectorAll('[data-qty-dec]').forEach((btn) => {
          btn.addEventListener('click', () => this._adjust(card, -1));
        });
      });
    }

    _adjust(card, delta) {
      const slug = card.dataset.flavorSlug;
      const current = this._selections.get(slug) || 0;
      const totalOthers = this._totalSelected() - current;
      const next = Math.max(0, Math.min(this._qtyTarget - totalOthers, current + delta));
      const wasZero = current === 0;

      if (next === 0) this._selections.delete(slug);
      else this._selections.set(slug, next);

      if (delta > 0 && wasZero && next > 0) {
        const meta = (this._config.flavorMeta || {})[slug];
        if (meta) this._fireToast(meta);
      }
      this._update();
    }

    _totalSelected() {
      let sum = 0;
      for (const q of this._selections.values()) sum += q;
      return sum;
    }

    _update() {
      const total = this._totalSelected();
      const remaining = this._qtyTarget - total;
      const pct = Math.min(100, Math.max(0, (total / this._qtyTarget) * 100));

      const counterCur = this.querySelector('[data-counter-current]');
      if (counterCur) counterCur.textContent = String(total);

      const bar = this.querySelector('[data-picker-bar-fill]');
      if (bar) {
        bar.style.setProperty('width', pct + '%', 'important');
        bar.style.setProperty('background', '#245835', 'important');
        bar.style.setProperty('height', '100%', 'important');
        bar.style.setProperty('display', 'block', 'important');
        bar.setAttribute('data-progress', String(pct));
        try {
          const cs = window.getComputedStyle(bar);
          console.log('[bpas] update total=' + total + ' pct=' + pct + ' inline=' + bar.style.width + ' computed.w=' + cs.width + ' computed.h=' + cs.height + ' computed.bg=' + cs.backgroundColor + ' computed.display=' + cs.display);
        } catch (e) { console.log('[bpas] computed err', e); }
      } else {
        console.log('[bpas] update bar=NULL (selector did not match)');
      }

      const counterPill = this.querySelector('[data-picker-counter]');
      if (counterPill) counterPill.style.color = total === this._qtyTarget ? 'var(--bpas-green-800)' : 'var(--bpas-green-400)';

      this.querySelectorAll('[data-flavor-card]').forEach((card) => {
        const slug = card.dataset.flavorSlug;
        const avail = card.dataset.flavorAvailable === 'true';
        const forceSoldout = card.dataset.forceSoldout === 'true';

        if (!avail || forceSoldout) {
          card.classList.add('is-locked');
          return;
        }

        const qty = this._selections.get(slug) || 0;
        const display = card.querySelector('[data-qty-display]');
        if (display) display.textContent = String(qty);

        card.classList.toggle('has-qty', qty > 0);

        const minus = card.querySelector('[data-qty-dec]');
        if (minus) minus.disabled = qty === 0;

        const plusInPill = card.querySelector('.qty [data-qty-inc]');
        if (plusInPill) plusInPill.disabled = remaining <= 0;

        const isLocked = remaining <= 0 && qty === 0;
        card.classList.toggle('is-locked', isLocked);

        const addBtn = card.querySelector('.qty-add[data-qty-inc]');
        if (addBtn) {
          addBtn.disabled = isLocked;
          addBtn.setAttribute('aria-disabled', isLocked ? 'true' : 'false');
        }
      });

      const cta = this.querySelector('[data-cta-checkout]');
      const ctaLabel = this.querySelector('[data-cta-label]');
      const ctaHelp = this.querySelector('[data-cta-help]');

      if (total === 0) {
        if (cta) cta.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'ESCOLHA OS SABORES';
        if (ctaHelp) {
          ctaHelp.classList.add('is-warn');
          ctaHelp.textContent = this._qtyTarget === 1
            ? 'Adicione 1 pote para continuar'
            : 'Adicione ' + this._qtyTarget + ' potes para continuar';
        }
      } else if (total < this._qtyTarget) {
        if (cta) cta.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'ESCOLHA OS SABORES';
        if (ctaHelp) {
          ctaHelp.classList.add('is-warn');
          ctaHelp.textContent = remaining === 1
            ? 'Falta 1 pote para finalizar'
            : 'Faltam ' + remaining + ' potes para finalizar';
        }
      } else {
        if (cta) {
          cta.disabled = this._submitting;
          cta.classList.toggle('is-loading', this._submitting);
          cta.setAttribute('aria-busy', this._submitting ? 'true' : 'false');
        }
        if (ctaLabel) ctaLabel.textContent = this._submitting ? '' : 'COMPRAR AGORA — ' + this._fmtBRL(this._pricing.now);
        if (ctaHelp) {
          ctaHelp.classList.remove('is-warn');
          ctaHelp.textContent = this._submitting ? '' : 'Tudo pronto! Garanta seu combo agora.';
        }
      }
    }

    _bindCta() {
      const cta = this.querySelector('[data-cta-checkout]');
      if (!cta) return;
      cta.addEventListener('click', async (e) => {
        e.preventDefault();
        if (this._submitting) return;
        if (this._totalSelected() !== this._qtyTarget) return;

        const bundleCombo = this._getBundleCombo();
        if (!bundleCombo) {
          this._showCheckoutError('Combo inválido. Volte e escolha seu combo novamente.');
          return;
        }
        const flavors = this._getSelectedFlavorsPayload();
        const sum = flavors.reduce((acc, f) => acc + f.quantity, 0);
        if (sum !== this._qtyTarget) {
          this._showCheckoutError('Complete a escolha dos sabores para continuar.');
          return;
        }

        if (this._shouldShowMonoUpsell(bundleCombo, flavors)) {
          const pickedFlavorId = flavors[0] && flavors[0].slug;
          const upsell = await this._ensureUpsellModal();
          if (upsell && pickedFlavorId) {
            upsell.open({ pickedFlavorId: pickedFlavorId });
            return;
          }
        }

        await this._startCheckout(bundleCombo, flavors);
      });
    }

    async _startCheckout(bundleCombo, flavors, extraAttributes) {
      const sum = (flavors || []).reduce((acc, f) => acc + (f && f.quantity ? f.quantity : 0), 0);
      if (!bundleCombo || sum <= 0) return;

      this._submitting = true;
      this._update();
      try {
        await this._submit(bundleCombo, flavors, extraAttributes || {});
      } catch (err) {
        console.error('[blessy-pdp-aniversario-sabores] create-cart failed:', err);
        this._submitting = false;
        this._update();
        this._showCheckoutError(err.message || 'Não foi possível abrir o checkout. Tente novamente.');
      }
    }

    _shouldShowMonoUpsell(bundleCombo, flavors) {
      const selectedQty = (flavors || []).reduce((acc, f) => acc + (f && f.quantity ? f.quantity : 0), 0);
      return bundleCombo === 'descoberta' && this._qtyTarget === 1 && selectedQty === 1;
    }

    async _waitForUpsellLib() {
      if (window.BlessyUpsell) return window.BlessyUpsell;
      await new Promise((resolve) => {
        let tries = 0;
        const tick = () => {
          if (window.BlessyUpsell || tries >= 40) return resolve();
          tries += 1;
          window.setTimeout(tick, 50);
        };
        tick();
      });
      return window.BlessyUpsell || null;
    }

    async _ensureUpsellModal() {
      if (this._upsell) return this._upsell;
      const lib = await this._waitForUpsellLib();
      const mount = document.querySelector('#bpas-upsell-mount');
      if (!lib || !mount) return null;
      const assets = (this._config && this._config.upsellAssets) || {};
      this._upsell = lib.init({
        mount: '#bpas-upsell-mount',
        assets: {
          mockup1Pote: assets.mockup1Pote,
          mockup3Potes: assets.mockup3Potes
        },
        flavors: this._getUpsellFlavorCatalog(),
        onAccept: (items) => this._handleUpsellAccept(items),
        onDecline: (items) => this._handleUpsellDecline(items),
        onClose: () => {}
      });
      return this._upsell;
    }

    _getUpsellFlavorCatalog() {
      const meta = (this._config && this._config.flavorMeta) || {};
      return Array.from(this.querySelectorAll('[data-flavor-card]')).map((card) => {
        const slug = card.dataset.flavorSlug;
        const rawName = card.dataset.flavorName || slug;
        const flavorMeta = meta[slug] || {};
        const img = card.querySelector('.flavor-image img');
        const available = card.dataset.flavorAvailable === 'true' && card.dataset.forceSoldout !== 'true';
        let tag = null;
        if (flavorMeta.badge === 'hot') tag = { type: 'hot', label: flavorMeta.badgeText || 'vendendo rápido' };
        if (flavorMeta.badge === 'low') tag = { type: 'low', label: flavorMeta.badgeText || 'estoque limitado' };
        return {
          id: slug,
          name: rawName.split('|').pop().trim(),
          image: img ? (img.currentSrc || img.src) : '',
          tag: tag,
          soldOut: !available
        };
      });
    }

    _upsellItemsToFlavors(items) {
      return (items || [])
        .map((item) => ({ slug: item.id, quantity: Number(item.n) }))
        .filter((item) => item.slug && Number.isInteger(item.quantity) && item.quantity > 0);
    }

    _handleUpsellAccept(items) {
      const flavors = this._upsellItemsToFlavors(items);
      return this._startCheckout('bestie', flavors, {
        monoUpsellShown: 'true',
        monoUpsellAccepted: 'true',
        upgradedFromCombo: 'descoberta',
        upsellTargetCombo: 'bestie'
      });
    }

    _handleUpsellDecline(items) {
      const flavors = this._upsellItemsToFlavors(items);
      return this._startCheckout('descoberta', flavors, {
        monoUpsellShown: 'true',
        monoUpsellAccepted: 'false'
      });
    }

    _getBundleCombo() {
      const params = new URLSearchParams(window.location.search);
      const quantity = parseInt(params.get('quantity') || String(this._qtyTarget), 10);
      const map = { 1: 'descoberta', 3: 'bestie', 5: 'aniversario' };
      return map[quantity] || null;
    }

    _getSelectedFlavorsPayload() {
      const out = [];
      for (const [slug, qty] of this._selections.entries()) {
        if (qty > 0 && slug) out.push({ slug, quantity: qty });
      }
      return out;
    }

    _getAttributionAttributes() {
      const KEYS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content',
                    'gclid','fbclid','ttclid'];
      const STORAGE_KEY = 'blessy_aniversario_attribution';
      const params = new URLSearchParams(window.location.search);
      let stored = {};
      try {
        stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
      } catch (e) {}
      const next = Object.assign({}, stored);
      KEYS.forEach((key) => {
        const v = params.get(key);
        if (v) next[key] = v;
      });
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {}
      return next;
    }

    _showCheckoutError(message) {
      const ctaHelp = this.querySelector('[data-cta-help]');
      if (!ctaHelp) return;
      ctaHelp.classList.add('is-warn');
      ctaHelp.textContent = message || 'Não foi possível abrir o checkout. Tente novamente.';
    }

    async _submit(bundleCombo, flavors, extraAttributes) {
      const payload = {
        offer: 'aniversario-2anos',
        bundleCombo: bundleCombo,
        flavors: flavors,
        attributes: Object.assign({}, this._getAttributionAttributes(), extraAttributes || {})
      };

      const response = await fetch('https://api.useblessy.com.br/create-cart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.message || 'Não foi possível criar seu checkout.');
      }
      if (!result.checkoutUrl) {
        throw new Error('Checkout não retornado.');
      }

      window.location.assign(result.checkoutUrl);
    }

    _setupNotyfIdleLoad() {
      const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 900));
      window.addEventListener('load', () => idle(() => this._loadNotyfAssets()), { once: true });
    }

    _loadNotyfAssets() {
      if (this._notyfPromise) return this._notyfPromise;
      const cfg = this._config;
      this._notyfPromise = new Promise((resolve) => {
        if (!document.querySelector('link[data-bpas-notyf-css]')) {
          const css = document.createElement('link');
          css.rel = 'stylesheet';
          css.href = cfg.notyfCss;
          css.dataset.bpasNotyfCss = 'true';
          document.head.appendChild(css);
        }
        if (typeof window.Notyf !== 'undefined') { resolve(); return; }
        const script = document.createElement('script');
        script.src = cfg.notyfJs;
        script.async = true;
        script.onload = resolve;
        script.onerror = resolve;
        document.head.appendChild(script);
      });
      return this._notyfPromise;
    }

    _getNotyf() {
      if (this._notyf) return this._notyf;
      if (typeof window.Notyf === 'undefined') return null;
      this._notyf = new window.Notyf({
        duration: 2000,
        ripple: false,
        position: { x: 'center', y: 'top' },
        dismissible: false,
        types: [
          { type: 'custom', background: '#ffffff', duration: 2000, dismissible: false }
        ]
      });
      return this._notyf;
    }

    _fireToast(meta) {
      if (!meta || !meta.toastText) return;
      this._loadNotyfAssets().then(() => {
        const n = this._getNotyf();
        if (!n) return;
        n.open({ type: 'custom', background: meta.toastBg, message: meta.toastText });
        requestAnimationFrame(() => {
          const nodes = document.querySelectorAll('.notyf__toast');
          const el = nodes[nodes.length - 1];
          if (el) el.style.background = meta.toastBg;
        });
      });
    }

    _notify(message) {
      this._loadNotyfAssets().then(() => {
        const n = this._getNotyf();
        if (n) n.open({ type: 'custom', background: '#E34040', message: message });
        else alert(message);
      });
    }
  }

  if (!customElements.get('blessy-pdp-aniversario-sabores')) {
    customElements.define('blessy-pdp-aniversario-sabores', BlessyPdpAniversarioSabores);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blessy-pdp-aniversario"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================================
     Web component: <blessy-pdp-aniversario>
     Portado de index.html. Adaptações pra Liquid:
       - document.querySelector → this.querySelector (escopa no shadow do componente)
       - URLs de imagem dinâmicas vêm do JSON config [data-bpa-config]
       - CTA redirect vai pra section.settings.url_sabores (passado via data-url-sabores)
     ============================================================================ */

  class BlessyPdpAniversario extends HTMLElement {
    connectedCallback() {
      // Read config JSON (passado do Liquid)
      const configEl = this.querySelector('[data-bpa-config]');
      this._config = configEl ? JSON.parse(configEl.textContent) : {};

      this._activeThumbIndex = 0;
      this._currentCombo = 'aniversario';
      this._prefetchedStep2 = new Set();
      this._lottieLoadPromise = null;

      this._buildCombosData();
      this._wireCombos();
      this._wireCta();
      this._wireGalleryNav();
      this._wireThumbs();
      this._wireFaq();
      this._moveCtaOutside();

      this.selectCombo('aniversario');

      // Re-render on breakpoint cross (mobile vs desktop pill text)
      this._wasMobile = window.matchMedia('(max-width: 767px)').matches;
      window.addEventListener('resize', () => {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (isMobile !== this._wasMobile) {
          this._wasMobile = isMobile;
          this.selectCombo(this._currentCombo);
        }
      });

      // Confetti: load Lottie when squeeze enters viewport
      this._initConfetti();

      // Prefetch step 2 on idle + on CTA hover/focus
      const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 900));
      window.addEventListener('load', () => idle(() => this._prefetchStep2()), { once: true });
    }

    _buildCombosData() {
      this._COMBOS = {
        descoberta: {
          offerFrom: 'de R$233,99', offerInt: '189', offerCent: '90',
          pillDisc: '-19%', pillSave: 'ECONOMIZE R$44,09',
          ctaSub: '1 mês de Blessy + frete grátis',
          brindesCount: '1 item', unlocked: ['frete'],
          perPote: 'R$189,90', totalStrike: 'R$233,99', totalNow: 'R$189,90',
          potesBrinde: this._config.brindePotes && this._config.brindePotes['1'],
          benefits: [
            { type: 'check', html: '<b>frete grátis</b> — em todos os envios' },
            { type: 'check', html: '<b>1 pote</b> Blessy® Greens — sabor a escolher' },
            { type: 'check', html: '<b>30 dias de garantia</b> — ou seu dinheiro de volta' }
          ]
        },
        bestie: {
          offerFrom: 'de R$593,70', offerInt: '327', offerCent: '00',
          pillDisc: '-45%', pillSave: 'ECONOMIZE R$266,70',
          ctaSub: '2 meses de Blessy + 1 pote grátis',
          brindesCount: '2 itens', unlocked: ['frete', 'potes'],
          perPote: 'R$109,00', totalStrike: 'R$593,70', totalNow: 'R$327,00',
          potesBrinde: this._config.brindePotes && this._config.brindePotes['1'],
          benefits: [
            { type: 'check', html: '<b>frete grátis</b> — em todos os envios' },
            { type: 'check', html: '<b>2 potes</b> Blessy® Greens — sabor a escolher' },
            { type: 'gift',  html: '<b>+1 pote</b> Blessy® Greens — de qualquer sabor', pill: 'grátis' },
            { type: 'gift',  html: '<b>+1 brinde extra</b> grátis', pill: 'grátis' },
            { type: 'check', html: '<b>30 dias de garantia</b> — ou seu dinheiro de volta' }
          ]
        },
        aniversario: {
          offerFrom: 'de R$1.037,50', offerInt: '467', offerCent: '00',
          pillDisc: '-55%', pillSave: 'ECONOMIZE R$570,50',
          ctaSub: '5 meses de Blessy + squeeze comemorativa',
          brindesCount: '3 itens', unlocked: ['frete', 'potes', 'squeeze'],
          perPote: 'R$93,40', totalStrike: 'R$1.037,50', totalNow: 'R$467,00',
          potesBrinde: this._config.brindePotes && this._config.brindePotes['2'],
          benefits: [
            { type: 'check', html: '<b>frete grátis</b> — em todos os envios' },
            { type: 'check', html: '<b>3 potes</b> Blessy® Greens — sabor a escolher' },
            { type: 'gift',  html: '<b>+2 potes</b> Blessy® Greens — de qualquer sabor', pill: 'grátis' },
            { type: 'gift',  html: '<b>squeeze Blessy®</b> grátis', pill: 'grátis' },
            { type: 'gift',  html: '<b>+1 brinde extra</b> grátis', pill: 'grátis' },
            { type: 'check', html: '<b>30 dias de garantia</b> — ou seu dinheiro de volta' }
          ]
        }
      };
      this._COMBO_SLIDE_ID = {
        descoberta:  'combo-descoberta',
        bestie:      'combo-bestie',
        aniversario: 'combo-aniversario'
      };
      this._THUMB_SLIDE_ID = [null, 'slide-2', 'slide-3', 'slide-4'];
    }

    _renderBenefits(combo) {
      const ul = this.querySelector('#benefits');
      const iconCheck = `<img src="${this._config.iconCheck}" width="15" height="16" alt="" aria-hidden="true" style="display:block;">`;
      const iconGift  = `<img src="${this._config.iconGift}" width="15" height="16" alt="" aria-hidden="true" style="display:block;">`;
      ul.innerHTML = combo.benefits.map((b) => {
        const icon = b.type === 'gift' ? iconGift : iconCheck;
        const pill = b.pill ? `<span class="pill-gratis">${b.pill}</span>` : '';
        const text = b.html.replace(/\s*—\s*(.+)$/, ' <span class="benefit-sub">— $1</span>');
        return `<li><span class="icon-wrap">${icon}</span><span>${text}</span>${pill}</li>`;
      }).join('');
    }

    _showSlide(id) {
      this.querySelectorAll('#gallery-main .product').forEach((img) => {
        img.classList.toggle('is-active', img.dataset.slide === id);
      });
    }

    selectCombo(key) {
      const combo = this._COMBOS[key];
      if (!combo) return;
      this._currentCombo = key;

      // Thumb 0 image swap (per combo)
      const thumb0 = this.querySelector('#thumb-0-img');
      const gComboUrl = this._config.galleryCombo && this._config.galleryCombo[key];
      if (thumb0 && gComboUrl) thumb0.src = gComboUrl;
      if (this._activeThumbIndex === 0) this._showSlide(this._COMBO_SLIDE_ID[key]);

      // Offer card
      this.querySelector('#offer-from').textContent = combo.offerFrom;
      this.querySelector('#offer-now-int').textContent = combo.offerInt;
      this.querySelector('#offer-now-cent').textContent = combo.offerCent;
      this.querySelector('#pill-disc').textContent = combo.pillDisc;

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const econValue = combo.pillSave.replace(/^ECONOMIZE\s+/i, '');
      this.querySelector('#pill-save').textContent = isMobile ? `- ${econValue} OFF` : combo.pillSave;

      this._renderBenefits(combo);

      // Brindes lock state
      this.querySelector('#brindes-count').textContent = combo.brindesCount;
      this.querySelectorAll('#brindes .brinde').forEach((el) => {
        const isUnlocked = combo.unlocked.includes(el.dataset.brinde);
        el.setAttribute('data-locked', isUnlocked ? 'false' : 'true');
      });

      this.querySelector('#cta-sub').textContent = combo.ctaSub;

      this.querySelector('#val-per-pote').textContent = combo.perPote;
      this.querySelector('#val-total-strike').textContent = combo.totalStrike;
      this.querySelector('#val-total-now').textContent = combo.totalNow;

      // Potes brinde card
      if (combo.potesBrinde) {
        const pb = combo.potesBrinde;
        const img = this.querySelector('#potes-image');
        const title = this.querySelector('#potes-title');
        const strike = this.querySelector('#potes-strike');
        if (img) { img.src = pb.image; img.alt = pb.alt; }
        if (title) title.textContent = pb.title;
        if (strike) strike.textContent = pb.strike;
      }

      // Combo card selected state
      this.querySelectorAll('#combos .combo').forEach((c) => {
        c.setAttribute('data-selected', c.dataset.combo === key ? 'true' : 'false');
      });
    }

    _wireCombos() {
      this.querySelectorAll('#combos .combo').forEach((btn) => {
        btn.addEventListener('click', () => this.selectCombo(btn.dataset.combo));
      });
    }

    _wireCta() {
      const cta = this.querySelector('#cta');
      const COMBO_QTY = {
        descoberta:  parseInt(this.dataset.qtyDescoberta, 10) || 1,
        bestie:      parseInt(this.dataset.qtyBestie, 10) || 3,
        aniversario: parseInt(this.dataset.qtyAniversario, 10) || 5
      };

      cta.addEventListener('click', () => {
        const qty = COMBO_QTY[this._currentCombo] || 1;
        const baseUrl = this.dataset.urlSabores || '/pages/carrinho-aniversario';
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('quantity', String(qty));
        url.searchParams.set('combo', this._currentCombo);
        this._preserveTrackingParams(url.searchParams);
        window.location.href = url.toString();
      });

      // Prefetch immediate em hover/focus/touch do CTA
      ['pointerenter', 'focus', 'pointerdown'].forEach((eventName) => {
        cta.addEventListener(eventName, () => this._prefetchStep2(true), { passive: true });
      });
    }

    _preserveTrackingParams(target) {
      const current = new URLSearchParams(window.location.search);
      const keep = ['gclid', 'fbclid', 'ttclid', 'msclkid', 'twclid'];
      for (const [key, value] of current.entries()) {
        if (key.startsWith('utm_') || keep.includes(key)) {
          target.set(key, value);
        }
      }
    }

    _prefetchStep2(immediate) {
      const run = () => {
        const baseUrl = this.dataset.urlSabores || '/pages/carrinho-aniversario';
        const qty = this._currentCombo === 'descoberta' ? 1 : (this._currentCombo === 'bestie' ? 3 : 5);
        this._prefetchResource(`${baseUrl}?quantity=${qty}`, 'document');
      };
      if (immediate) run();
      else {
        const idle = window.requestIdleCallback || ((cb) => window.setTimeout(cb, 900));
        idle(() => window.setTimeout(run, 2600));
      }
    }

    _prefetchResource(href, as, media) {
      const key = `${as}:${href}:${media || ''}`;
      if (this._prefetchedStep2.has(key)) return;
      this._prefetchedStep2.add(key);
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = as;
      if (media) link.media = media;
      document.head.appendChild(link);
    }

    _wireGalleryNav() {
      const slidePrev = this.querySelector('#slide-prev');
      const slideNext = this.querySelector('#slide-next');
      const syncBoundary = () => {
        slidePrev.setAttribute('data-disabled', this._activeThumbIndex === 0 ? 'true' : 'false');
        slideNext.setAttribute('data-disabled', this._activeThumbIndex === 3 ? 'true' : 'false');
      };
      const goToThumb = (idx) => {
        const next = Math.max(0, Math.min(3, idx));
        if (next === this._activeThumbIndex) return;
        this.querySelectorAll('#thumbs .thumb').forEach((t) => {
          t.classList.toggle('active', parseInt(t.dataset.thumb, 10) === next);
        });
        this._activeThumbIndex = next;
        const id = next === 0 ? this._COMBO_SLIDE_ID[this._currentCombo] : this._THUMB_SLIDE_ID[next];
        this._showSlide(id);
        syncBoundary();
      };
      slidePrev.addEventListener('click', () => goToThumb(this._activeThumbIndex - 1));
      slideNext.addEventListener('click', () => goToThumb(this._activeThumbIndex + 1));
      syncBoundary();
      this._goToThumb = goToThumb;
    }

    _wireThumbs() {
      this.querySelectorAll('#thumbs .thumb').forEach((btn) => {
        btn.addEventListener('click', () => {
          const idx = parseInt(btn.dataset.thumb, 10);
          this.querySelectorAll('#thumbs .thumb').forEach((t) => t.classList.remove('active'));
          btn.classList.add('active');
          this._activeThumbIndex = idx;
          const id = idx === 0 ? this._COMBO_SLIDE_ID[this._currentCombo] : this._THUMB_SLIDE_ID[idx];
          this._showSlide(id);
          if (this._goToThumb) this._goToThumb(idx);
        });
      });
    }

    _wireFaq() {
      this.querySelector('#faq').addEventListener('click', (e) => {
        const trigger = e.target.closest('.faq-trigger');
        if (!trigger) return;
        const item = trigger.parentElement;
        const wasOpen = item.dataset.open === 'true';
        this.querySelectorAll('#faq .faq-item').forEach((i) => {
          i.dataset.open = 'false';
          const t = i.querySelector('.faq-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.dataset.open = 'true';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    _initConfetti() {
      const container = this.querySelector('#confetti-lottie');
      if (!container) return;

      const loadLottie = () => {
        if (window.lottie) return Promise.resolve(window.lottie);
        if (this._lottieLoadPromise) return this._lottieLoadPromise;
        this._lottieLoadPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
          script.async = true;
          script.onload = () => resolve(window.lottie);
          script.onerror = reject;
          document.head.appendChild(script);
        });
        return this._lottieLoadPromise;
      };

      const startConfetti = () => {
        if (container.dataset.loaded === '1') return;
        container.dataset.loaded = '1';
        loadLottie().then((lottieApi) => {
          if (!lottieApi || !this._config.confettiUrl) return;
          lottieApi.loadAnimation({
            container, renderer: 'svg', loop: true, autoplay: true,
            path: this._config.confettiUrl
          });
        });
      };

      if ('IntersectionObserver' in window) {
        const obs = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          obs.disconnect();
          startConfetti();
        }, { rootMargin: '0px 0px' });
        obs.observe(container);
      } else {
        window.addEventListener('load', startConfetti, { once: true });
      }
    }

    _moveCtaOutside() {
      const pdpRight = this.querySelector('.pdp-right');
      const valueRow = this.querySelector('#value-row');
      const ctaWrap = this.querySelector('.cta-wrap');
      const guarantee = this.querySelector('.guarantee');
      if (!pdpRight || !ctaWrap || !guarantee) return;
      ctaWrap.classList.add('is-outside');
      guarantee.classList.add('is-outside');
      if (valueRow) {
        valueRow.classList.add('is-outside');
        pdpRight.appendChild(valueRow);
      }
      pdpRight.appendChild(ctaWrap);
      pdpRight.appendChild(guarantee);
    }
  }

  if (!customElements.get('blessy-pdp-aniversario')) {
    customElements.define('blessy-pdp-aniversario', BlessyPdpAniversario);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
